import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import { Alert } from "react-bootstrap";
import axios from "axios";

const StepOne = ({ onNext }) => {
  const { t } = useTranslation();
  const [companyDetails, setCompanyDetails] = useState({
    name: "",
    address: "",
    phoneNumber: "",
    email: "",
    stepNumber: 1,
  });
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get("/step1");
        if (response.data && response.data.status && response.data.step1) {
          setCompanyDetails(response.data.step1);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
        setError(t('steps.failedToLoadCompanyDetails'));
      }
    };
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await axios.post("/step1", companyDetails);
      onNext(); // Move to next step
    } catch (err) {
      console.error("Error saving data:", err);
      setError(t('steps.failedToSaveCompanyDetails'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-sm">
      <form className="row g-3 p-4 px-5" onSubmit={handleSubmit}>
        {error && <Alert variant="danger">{error}</Alert>}
        <h5 className="text-[30px] font-semibold leading-[110%] text-[#25324B] tracking-wide">
          {t('steps.basicInformation')}
        </h5>
        {/* Company Name */}
        <div className="col-md-6">
          <label htmlFor="companyName" className="form-label font-semibold text-gray-800 text-lg">
            {t('steps.companyName')}
          </label>
          <div className="input-group">
            <span className="input-group-text">
              <i className="bi bi-building text-primary"></i>
            </span>
            <input
              type="text"
              className="form-control"
              id="companyName"
              value={companyDetails?.name || ""}
              onChange={(e) =>
                setCompanyDetails({ ...companyDetails, name: e.target.value })
              }
              required
            />
          </div>
        </div>

        {/* Address */}
        <div className="col-md-6">
          <label htmlFor="address" className="form-label font-semibold text-gray-800 text-lg">
            {t('steps.address')}
          </label>
          <div className="input-group">
            <span className="input-group-text">
              <i className="bi bi-geo-alt text-danger"></i> {/* Bootstrap Location Icon (Red for visibility) */}
            </span>
            <input
              type="text"
              className="form-control"
              id="address"
              value={companyDetails?.address || ""}
              onChange={(e) =>
                setCompanyDetails({ ...companyDetails, address: e.target.value })
              }
              required
            />
          </div>
        </div>

        {/* Phone Number */}
        <div className="col-md-6">
          <label htmlFor="phoneNumber" className="form-label font-semibold text-gray-800 text-lg">
            {t('steps.phoneNumber')}
          </label>
          <div className="input-group">
            <span className="input-group-text">📞</span>
            <input
              type="text"
              className="form-control"
              id="phoneNumber"
              value={companyDetails?.phoneNumber || ""}
              onChange={(e) =>
                setCompanyDetails({
                  ...companyDetails,
                  phoneNumber: e.target.value,
                })
              }
            />
          </div>
        </div>

        {/* Email */}
        <div className="col-md-6">
          <label htmlFor="email" className="form-label font-semibold text-gray-800 text-lg">
            {t('faqs.email')}
          </label>
          <div className="input-group">
          <span className="input-group-text">
            <i className="bi bi-envelope text-primary"></i> {/* Bootstrap envelope icon with blue color */}
          </span>
            <input
              type="email"
              className="form-control"
              id="email"
              value={companyDetails?.email || ""}
              onChange={(e) =>
                setCompanyDetails({ ...companyDetails, email: e.target.value })
              }
            />
          </div>
        </div>

        {/* Submit Button */}
        <div className="col-12 d-flex justify-content-end">
          <button
            type="submit"
            className="btn btn-success fs-5 mb-3 !px-6"
            disabled={loading}
          >
{loading ? t('answers.saving') : t('steps.next')}
          </button>
        </div>
      </form>
    </div>
  );
};

export default StepOne;
